import { useNavigation } from "@react-navigation/native";
import background from "assets/images/backgroundRotated.png";
import theme from "assets/theme";
import React, { useCallback, useContext, useMemo, useState } from "react";
import { Button, Image, StyleSheet, Text, View } from "react-native";
import PersonService from "services/Person.service";
import passwordSchema from "utils/passwordValidator";
import { SCREEN_ADMIN_LOGIN } from "web/constants";
import Overlay from "webComponentsFormElements/Overlay.component";
import LabelInput from "webComponentsFormElements/inputs/LabelInput.component";
import { AuthContext } from "webContext/Auth.context";
import { ToastContext } from "webContext/Toast.context";

const classes = StyleSheet.create({
  root: {
    width: "100vw",
    height: "100vh",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
  },
  imageContainer: {
    width: "100%",
    alignItems: "center",
  },
  logoImage: {
    width: "100%",
    height: "250px",
  },
  bgImage: {
    position: "absolute",
    opacity: 0.9,
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  card: {
    alignSelf: "flex-end",
    backgroundColor: "rgba(49, 120, 170, 1)",
    borderLeftColor: "rgb(110, 182, 234)",
    borderLeftWidth: 2,
    height: "100%",
    minWidth: "500px",
    width: "20%",
    justifyContent: "space-evenly",
    alignItems: "center",
  },
  headerText: {
    fontSize: 28,
    color: theme.color.white,
  },
  inputContainer: {
    width: "65%",
    alignItems: "center",
  },
  headerContainer: {
    marginBottom: 8,
    width: "80%",
    alignItems: "center",
  },
  buttonContainer: {
    width: "100%",
    marginTop: 32,
    marginBottom: 32,
  },
});

export default function ResetPassword(props) {
  const { userId, key } = props.route.params;

  const { logout } = useContext(AuthContext);
  const { showToast } = useContext(ToastContext);

  const navigation = useNavigation();

  const [hasReset, setHasReset] = useState(false);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const isPasswordValid = useMemo(
    () => passwordSchema.validate(password),
    [password],
  );
  const handleReset = useCallback(async () => {
    try {
      await PersonService.updatePassword(userId, {
        key,
        newPassword: password,
      });
      logout();
      showToast(
        "Successfully reset your password! Login on the mobile app or return to the admin login screen.",
        "success",
      );
      setHasReset(true);
    } catch {
      showToast("An error occurred while resetting your password.", "error");
    }
  }, [userId, key, password, logout, showToast]);

  return (
    <View style={classes.root}>
      <Image source={background} resizeMode="cover" style={classes.bgImage} />
      <View style={classes.cardBackground} />
      <View style={classes.card}>
        <Overlay />
        <View style={classes.inputContainer}>
          <View style={classes.headerContainer}>
            <Text style={classes.headerText}>Password Reset</Text>
          </View>
          <LabelInput
            variant="white"
            label="New Password"
            isPassword
            required
            disabled={hasReset}
            hasErrorOnBlur={password !== "" && !isPasswordValid}
            onChangeText={setPassword}
            value={password}
            tooltip={
              <View>
                <Text style={classes.tooltipHeader}>
                  Must contain at least:
                </Text>
                <Text style={classes.tooltipItem}>8 Characters</Text>
                <Text style={classes.tooltipItem}>1 Number</Text>
                <Text style={classes.tooltipItem}>1 Uppercase Letter</Text>
                <Text style={classes.tooltipItem}>1 Lowercase Letter</Text>
                <Text style={classes.tooltipItem}>1 Special Character</Text>
              </View>
            }
          />
          <LabelInput
            variant="white"
            label="Confirm New Password"
            isPassword
            required
            disabled={hasReset}
            hasErrorOnBlur={
              confirmPassword !== "" &&
              password !== "" &&
              password !== confirmPassword
            }
            onChangeText={setConfirmPassword}
            value={confirmPassword}
          />
          <View style={classes.buttonContainer}>
            <Button
              title={hasReset ? "Return to login" : "Reset"}
              color={theme.color.primary}
              disabled={!isPasswordValid || confirmPassword !== password}
              onPress={() =>
                hasReset
                  ? navigation.navigate(SCREEN_ADMIN_LOGIN)
                  : handleReset()
              }
            />
          </View>
        </View>
      </View>
    </View>
  );
}
